import React, { FC, useState } from "react";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Snackbar } from "@mui/material";

interface CopyButtonProps {
  prompt: string;
  onClick?: (e) => void;
}

const CopyButton: FC<CopyButtonProps> = ({
  prompt,
  onClick = (e) => {},
  children,
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setOpen(true);
    onClick(e);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <p
          className="caption p-16 bg-opacity-90 bg-white text-primary-dark-grey"
          style={{ borderRadius: "4px" }}
        >
          {prompt}
        </p>
      </Snackbar>
      <button
        className="flex flex-row justify-between items-center space-x-10"
        onClick={handleClick}
      >
        <p className="body2">{children}</p>
        <FileCopyIcon className="fill-current" style={{ fontSize: "16px" }} />
      </button>
    </>
  );
};

export default CopyButton;
